import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
            <div className="lg:w-1/3">
              <a href="/" className="inline-block font-heading text-xl font-semibold text-foreground-900 mb-3 cursor-pointer">
                Vigorbuy Spread
              </a>
              <p className="text-sm text-foreground-500 leading-relaxed max-w-sm">
                An independent informational platform providing educational resources, product guides, comparisons and shopping information related to Vigorbuy Spreadsheet. We are not the official Vigorbuy website.
              </p>
            </div>

            <div className="flex flex-wrap gap-8 lg:gap-16">
              <div>
                <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">Quick Links</h4>
                <ul className="space-y-2.5">
                  <li>
                    <a href="/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer">Home</a>
                  </li>
                  <li>
                    <button
                      onClick={() => navigate('/article/complete-vigorbuy-spreadsheet-guide-2026')}
                      className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer"
                    >
                      Complete Guide
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => navigate('/article/vigorbuy-spreadsheet-safety-guide')}
                      className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer"
                    >
                      Safety Guide
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => navigate('/article/vigorbuy-spreadsheet-categories-explained')}
                      className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer"
                    >
                      Categories Explained
                    </button>
                  </li>
                  <li>
                    <a
                      href="https://kaspreadsheet.com"
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer"
                    >
                      Visit Main Website
                    </a>
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">Popular Categories</h4>
                <ul className="space-y-2.5">
                  <li>
                    <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer">Shoes</a>
                  </li>
                  <li>
                    <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer">Hoodies/Sweaters</a>
                  </li>
                  <li>
                    <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer">T-Shirts</a>
                  </li>
                  <li>
                    <a href="https://kaspreadsheet.com/search-920/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer">Accessories</a>
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">SEO Guides</h4>
                <ul className="space-y-2.5">
                  <li>
                    <button
                      onClick={() => navigate('/article/how-to-use-vigorbuy-spreadsheet')}
                      className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer"
                    >
                      Beginner Tutorial
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => navigate('/article/best-vigorbuy-spreadsheet-finds-2026')}
                      className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer"
                    >
                      Best Finds 2026
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => navigate('/article/vigorbuy-spreadsheet-qc-photos-guide')}
                      className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer"
                    >
                      QC Photos Guide
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => navigate('/article/vigorbuy-spreadsheet-shopping-strategy')}
                      className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer"
                    >
                      Shopping Strategy
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="border-t border-background-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} Vigorbuy Spread. All rights reserved. Independent informational platform.
            </p>
            <p className="text-xs text-foreground-400">
              Not affiliated with any official brand. Educational resource only.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}